module.exports = __webpack_public_path__ + "static/media/Explore huge requirements.f4f61fa7.png";